import PortalIdParser from 'PortalIdParser';
const RESTOREABLE_LOCATION_STATE_KEY = 'RESTOREABLE_LOCATION_STATE';
export const makeRestoreableLocationStateKey = (locationName, objectTypeId) => {
  if (!objectTypeId) {
    return `${RESTOREABLE_LOCATION_STATE_KEY}:${PortalIdParser.get()}:${locationName}`;
  }
  return `${RESTOREABLE_LOCATION_STATE_KEY}:${PortalIdParser.get()}:${locationName}:${objectTypeId}`;
};